import { APIEntityType, ArdoqId } from '@ardoq/api-types';
import { EnhancedScopeData, RepresentationData } from '@ardoq/data-model';
import { ArdoqIcon } from '@ardoq/icons';
import { enhancedScopeDataOperations } from '@ardoq/scope-data';

/**
 * @deprecated Use @ardoq/scope-data instead
 */
export const getComponentRepresentationData = (
  id: string,
  enhancedScopeData: EnhancedScopeData
): RepresentationData & { icon: ArdoqIcon; value: string } =>
  enhancedScopeDataOperations.getComponentRepresentationData(
    enhancedScopeData,
    id
  );

/**
 * @deprecated Use @ardoq/scope-data instead
 */
export const getComponentTypeRepresentationData = (
  entityId: ArdoqId,
  parentEntityId: ArdoqId | undefined,
  enhancedScopeData: EnhancedScopeData
) =>
  enhancedScopeDataOperations.getComponentTypeRepresentationData(
    enhancedScopeData,
    entityId,
    parentEntityId
  );

/**
 * @deprecated Use @ardoq/scope-data instead
 */
export const DEFAULT_COLOR = 'DEFAULT_COLOR';

/**
 * @deprecated Use @ardoq/scope-data instead
 */
export const getColor = (
  entityType: APIEntityType,
  entityId: ArdoqId | number,
  enhancedScopeData: EnhancedScopeData,
  parentEntityId?: ArdoqId
) =>
  enhancedScopeDataOperations.getColor(
    enhancedScopeData,
    entityType,
    entityId,
    parentEntityId
  );

/**
 * @deprecated Use @ardoq/scope-data instead
 */
export const getComponentColor = (
  id: string,
  enhancedScopeData: EnhancedScopeData
) => enhancedScopeDataOperations.getComponentColor(enhancedScopeData, id);

/**
 * @deprecated Use @ardoq/scope-data instead
 */
export const getComponentTypeColor = (
  id: string,
  parentId: string,
  enhancedScopeData: EnhancedScopeData
) =>
  enhancedScopeDataOperations.getComponentTypeColor(
    enhancedScopeData,
    id,
    parentId
  );

/**
 * @deprecated Use @ardoq/scope-data instead
 */
export const getFallbackComponentRepresentation = () =>
  enhancedScopeDataOperations.getFallbackComponentRepresentation();
